<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-form @submit.prevent="handleSubmit" ref="form">
      <v-card :disabled="loading">
        <v-card-title class="d-flex align-center justify-space-between">
          <span>
            {{ __("Receber") }} {{ documents.length }}
            {{ documents.length === 1 ? __("anexo") : __("anexos") }}
          </span>

          <v-btn icon @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col>
              <v-chip-group>
                <v-chip
                  v-for="document in documents"
                  :key="document.id"
                  :close="documents.length > 1"
                  @click:close="handleRemoveDocument(document)"
                >
                  {{ document.category.name }}
                </v-chip>
              </v-chip-group>
            </v-col>
          </v-row>

          <v-text-field
            v-model="form.receipt_date"
            :label="__('Data de recebimento')"
            type="date"
            :error-messages="errors.receipt_date"
            autofocus
            :max="formatDateForInput(new Date())"
          />

          <v-alert
            v-for="message in messages"
            :key="message.id"
            :type="message.type"
            text
            border="left"
          >
            <b>{{ message.name }}</b
            >:
            {{ message.reason }}
          </v-alert>
        </v-card-text>

        <v-card-actions>
          <v-spacer />

          <v-btn @click="close()" text>
            {{ __("Cancelar") }}
          </v-btn>
          <v-btn type="submit" color="primary" :loading="loading">
            {{ __("Salvar") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import i18n from "@/mixins/i18n";
import { formatDateForInput } from "@/tools/date";

export default {
  mixins: [i18n],

  components: {},

  props: {},

  data() {
    return {
      dialog: false,
      documents: [],
      form: {},
      formatDateForInput,
      errors: {},
      loading: false,
      messages: [],
    };
  },

  methods: {
    open(documents) {
      this.resetState();
      this.documents = [...documents];
      this.dialog = true;
      this.form.receipt_date = formatDateForInput(new Date());
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => this.resetState());
    },
    handleSubmit() {
      this.errors = {};
      this.messages = [];
      this.$emit("submit", {
        documents: this.documents,
        form: this.form,
      });
    },
    setErrors(errors) {
      this.errors = errors;
    },
    setLoading(loading) {
      this.loading = loading;
    },
    setMessages(messages) {
      this.messages = messages;
    },
    handleRemoveDocument(document) {
      this.documents = this.documents.filter((item) => item.id !== document.id);
    },
    resetState() {
      this.documents = [];
      this.form = { receipt_date: formatDateForInput(new Date()) };
      this.errors = {};
      this.messages = [];
      this.loading = false;
    },
  },

  computed: {},
};
</script>
